import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { ScrollArea } from "~/components/ui/scroll-area";
import { X } from "lucide-react";

type ImprintPopUpProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  location: {
    imprintCompany?: string | null;
    imprintFirstName?: string | null;
    imprintLastName?: string | null;
    imprintStreet?: string | null;
    imprintHouseNumber?: string | null;
    imprintZipCode?: string | null;
    imprintCity?: string | null;
    imprintCountry?: string | null;
  } | null;
};

export function ImprintPopUp({
  open,
  onOpenChange,
  location,
}: ImprintPopUpProps) {
  if (!location) return null;

  const responsibleName = [location.imprintFirstName, location.imprintLastName]
    .filter(Boolean)
    .join(" ");

  const address = [
    location.imprintStreet && location.imprintHouseNumber
      ? `${location.imprintStreet} ${location.imprintHouseNumber}`
      : location.imprintStreet || location.imprintHouseNumber,
    location.imprintZipCode && location.imprintCity
      ? `${location.imprintZipCode} ${location.imprintCity}`
      : location.imprintZipCode || location.imprintCity,
    location.imprintCountry,
  ].filter(Boolean);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        closeButtonVariant="white"
        className="fixed top-1/2 left-1/2 w-[720px] p-0 gap-0 data-[state=open]:slide-in-from-bottom-4"
      >
        <DialogHeader
          variant="black"
          className="flex flex-row items-center justify-between px-6 py-3 space-y-0"
        >
          <DialogTitle className="text-sm font-medium">Impressum</DialogTitle>
        </DialogHeader>
        <div className="bg-[#F9F9F9] p-5">
          <div className="flex flex-col gap-6 bg-white p-3 rounded-md">
            {/* Responsibility Section */}
            <div>
              <p className="text-sm mb-2">
                Für die Inhalte dieses Exposés ist verantwortlich:
              </p>
              {location.imprintCompany && (
                <h2 className="text-2xl font-bold mb-4">
                  {location.imprintCompany}
                </h2>
              )}
              {responsibleName && (
                <div className="flex flex-col gap-1">
                  <p>{responsibleName}</p>
                </div>
              )}
              {address.length > 0 && (
                <div className="flex flex-col">
                  {address.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              )}
            </div>

            {/* Legal Notice Section */}
            <div className="mt-8">
              <h3 className="text-base font-bold mb-2">
                Wichtiger rechtlicher Hinweis:
              </h3>
              <p className="text-sm leading-relaxed">
                Locationguide24 ist ein Internetportal für
                Veranstaltungslocations und Tagungsstätten.
                <br />
                Der Betreiber stellt diese Plattform lediglich zur
                Veröffentlichung von Inseraten zur Verfügung und ist dabei zu
                keiner Zeit vermittelnd tätig. Für Inserate und dessen Inhalte
                übernimmt der Betreiber daher weder Verantwortung noch Haftung.
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
